export default __webpack_public_path__ + "static/media/03.af9813d7.svg";